import React, { Component } from 'react'
import './index.less'
import { jumpToUser } from 'src/helper/webviewFun'


/**
 * @Author: KK
 * @Date: 2022-12-09
 * @LastEditors: KK
 * @LastEditTime: 2022-12-09
 * @desc: 排行榜
 */

export default class Rank extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { funcState, rankingList, prizeImage } = this.props
    return (
      <div className="big-prize-rank-main" style={{ display: `${funcState == 5 ? 'block' : 'none'}` }}>
        <div className="rank-scroll-box">
          {
            rankingList && rankingList.length > 0 && (
              <div className="user-rank-top">
                <div className="rank-order">
                  <img src="/img/app/gashapon/1.png" alt="" />
                </div>
                <div className="avatar" onClick={() => jumpToUser(rankingList[0].uid)}>
                  <img src={rankingList[0].avatarurl} alt="" />
                </div>
                <div className="info">
                  <div className="name">{rankingList[0].nickname}</div>
                  <div className="id">ID:{rankingList[0].duid}</div>
                </div>
                <img src={prizeImage} alt="" className='prize-icon' />
                <div className="prize-num">{rankingList[0].num}</div>
              </div>
            )
          }

          {
            rankingList && rankingList.length > 1 && (
              <div className="user-rank-top">
                <div className="rank-order">
                  <img src="/img/app/gashapon/2.png" alt="" />
                </div>
                <div className="avatar" onClick={() => jumpToUser(rankingList[1].uid)}>
                  <img src={rankingList[1].avatarurl} alt="" />
                </div>
                <div className="info">
                  <div className="name">{rankingList[1].nickname}</div>
                  <div className="id">ID:{rankingList[1].duid}</div>
                </div>
                <img src={prizeImage} alt="" className='prize-icon' />
                <div className="prize-num">{rankingList[1].num}</div>
              </div>
            )
          }

          {
            rankingList && rankingList.length > 2 && (
              <div className="user-rank-top">
                <div className="rank-order">
                  <img src="/img/app/gashapon/3.png" alt="" />
                </div>
                <div className="avatar" onClick={() => jumpToUser(rankingList[2].uid)}>
                  <img src={rankingList[2].avatarurl} alt="" />
                </div>
                <div className="info">
                  <div className="name">{rankingList[2].nickname}</div>
                  <div className="id">ID:{rankingList[2].duid}</div>
                </div>
                <img src={prizeImage} alt="" className='prize-icon' />
                <div className="prize-num">{rankingList[2].num}</div>
              </div>
            )
          }

          {
            rankingList && rankingList.length > 3 && rankingList.map((item, index) => {
              if (index > 2) {
                return (
                  <div className="user-rank-top" key={item.uid}>
                    <div className="rank-order">
                      {item.rank}
                    </div>
                    <div className="avatar" onClick={() => jumpToUser(item.uid)}>
                      <img src={item.avatarurl} alt="" />
                    </div>
                    <div className="info">
                      <div className="name">{item.nickname}</div>
                      <div className="id">ID:{item.duid}</div>
                    </div>
                    <img src={prizeImage} alt="" className='prize-icon' />
                    <div className="prize-num">
                      {item.num}
                    </div>
                  </div>
                )
              }
            })
          }
        </div>

        {
          rankingList.length <= 0 && (
            <div className='null'>
              <img src="/img/content_null_1.png" alt="" />
            </div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/gashapon/RankView/index.js